<template>
  <div :style="`width:${dispW}px; height:${dispH}px;`">
    <el-container>
      <el-main>
        <div class="map-form">
          <MapForm
            :isSelectVisibleBoolen="false"
            :dispW="Math.floor(dispW / 2 - 40)"
            :dispH="Math.floor(dispH / 2 - 20)"
            :parentForm="parentForm"
            :indexInForm="0"
            :isRGP="true"
            :mapValues="mapValues"
            :rgpPos="rgpPos"
            :rgpDia="rgpDia"
          ></MapForm>
        </div>
        <el-footer :style="`height:${dispH / 2}px;padding:0px;`">
          <RGPRiseArch :dispH="dispH / 4" :RgpHelper="RgpHelper"></RGPRiseArch>
          <RGPThick
            :dispH="dispH / 4"
            :dataX="thickDataX"
            :dataY="thickDataY"
            :rotateAngle="rotateAngle"
          ></RGPThick>
          <!-- <TrendChart></TrendChart> -->
        </el-footer>
      </el-main>
      <el-aside :style="`width:${dispW / 2 + 40}px`">
        <RGPManufacturer
          :dispW="dispW / 2 + 40"
          :RgpHelper="RgpHelper"
          @lensChange="onLensChange"
          :mapValues="mapValues"
          :record="record"
          :currentEye="currentEye"
        />
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import MapForm from "./MapForm.vue";
import Map from "./Map.vue";
import TrendChart from "./TrendChart";
import RGPManufacturer from "./RGP-Manufacturer";
import RGPRiseArch from "./RGP-RiseArch";
import RGPThick from "./RGP-Thick";
import { stopWaiting, isDefined } from "../shared";
import Rgp from "../js/RGP";
import { TOPOGRAPHYMODES } from "../../shared/consts";
import { TOPOGRAPHYEVENTS } from "../shared/events";
import { saveRgpPosSettings } from "../../settings";
import { isDataValid, objectCopy } from "../../shared/utils";

export default {
  name: "RGP",
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    mapValues: {
      type: Object,
      default() {
        return {};
      }
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: ""
    },
    value: Boolean
  },
  components: {
    MapForm,
    Map,
    TrendChart,
    RGPManufacturer,
    RGPRiseArch,
    RGPThick
  },
  data() {
    return {
      RgpHelper: null,
      parentForm: TOPOGRAPHYMODES.contectlens.key,
      offset: { x: 0, y: 0, z: 5 },
      updateLensOnly: false,
      curLenInfo: {},
      thickDataX: [],
      thickDataY: [],
      rotateAngle: 0,
      rgpPos: window.rgpPosSettings,
      rgpDia: 6
    };
  },
  created() {
    this.RgpHelper = new Rgp(this.$store.state.topography.casePath);
    const { offsetX, offsetY, offsetZ } = window.rgpPosSettings;
    this.offset.x = offsetX;
    this.offset.y = offsetY;
    this.offset.z = offsetZ;

    this.initRgp();
  },
  mounted() {
    if (this.mapValues && this.mapValues.params) {
      const { AxisFlat } = this.mapValues.params;
      if (isDataValid(AxisFlat.value)) {
        this.rotateAngle = AxisFlat.value;
      } else {
        this.rotateAngle = 45;
      }
    }
    this.$bus.$on(TOPOGRAPHYEVENTS.rgpOffsetChanged, (offset) => {
      const { offsetX, offsetY, offsetZ } = offset;
      this.offset.x = parseFloat(offsetX._toFixed(2));
      this.offset.y = parseFloat(offsetY._toFixed(2));
      this.offset.z = offsetZ || this.offset.z;
      window.rgpPosSettings = {
        offsetX: this.offset.x,
        offsetY: this.offset.y,
        offsetZ: this.offset.z
      };
      this.rgpPos = objectCopy(window.rgpPosSettings);
      saveRgpPosSettings({
        offsetX: this.offset.x,
        offsetY: this.offset.y,
        offsetZ: this.offset.z
      });
      this.updateMapAnd3D();
    });
    this.$bus.$on(TOPOGRAPHYEVENTS.rgpRotate, (angle) => {
      this.rotateAngle = angle;
      this.updateThickData();
    });

    this.$emit("hide-waiting");
  },
  methods: {
    initRgp() {
      this.RgpHelper.fInitPtrs();
    },
    onLensChange(curLenInfo) {
      this.curLenInfo = curLenInfo;

      this.rgpDia = 0;
      if (isDefined(curLenInfo) && isDefined(curLenInfo.width)) {
        curLenInfo.width.forEach((width) => {
          this.rgpDia += width;
        });
        this.produceLens(curLenInfo);
      }
    },
    produceLens(curLenInfo) {
      if (!isDefined(curLenInfo) || !isDefined(curLenInfo.r) || !isDefined(this.RgpHelper)) {
        return;
      }
      let result = this.RgpHelper.fProduceLens(
        curLenInfo.r,
        curLenInfo.width,
        curLenInfo.ecc,
        curLenInfo.r.length
      );
      if (result) {
        this.updateMapAnd3D(true);
      }
    },
    updateMapAnd3D(needUpdateLens = false) {
      let result = this.RgpHelper.fGenTransMatrix(
        this.offset.y,
        -this.offset.x,
        this.offset.z / 1000
      );

      if (!result) {
        return;
      }
      let obj = this.RgpHelper.fGetMapData(needUpdateLens);
      if (obj.result) {
        let mapData = obj.mapData;
        this.$bus.$emit(TOPOGRAPHYEVENTS.rgpDataChanged, mapData);
        this.updateThickData();
      }
    },

    updateThickData() {
      let obj = this.RgpHelper.fGetTearThickData(
        this.rotateAngle,
        this.curLenInfo.width,
        this.curLenInfo.width.length
      );

      if (obj.result) {
        this.thickDataX = obj.data.x;
        this.thickDataY = obj.data.y;
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off(TOPOGRAPHYEVENTS.rgpOffsetChanged);
    this.$bus.$off(TOPOGRAPHYEVENTS.rgpRotate);
    this.RgpHelper.freePtrs();
  }
};
</script>

<style scoped>
.el-main,
.el-aside,
.el-container {
  padding: 0px;
  margin: px;
}
.map-form {
  border-bottom: 1px gray solid;
}
.el-footer {
  padding: 0px;
  padding-left: 5px;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP.vue